import styled from 'styled-components'
import theme, {colors} from '../../../styles/theme'

export const DashboardBox = styled.div`
  display: flex;
  justify-content: space-between;
`

export const LeftBox = styled.div`
  min-width: 250px;
  position: relative;

  @media only screen and (max-width: 1015px) {
    min-width: 200px;
  }

  ${theme.breakpoints.down('md')} {
    display: none;
  }
`

export const CentralBox = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 32px 32px 64px;

  @media only screen and (max-width: 1080px) {
    padding: 32px 20px 64px;
  }

  ${theme.breakpoints.down('md')} {
    padding: 16px 20px 64px;
  }

  ${theme.breakpoints.down('sm')} {
    padding: 16px 16px 64px;
  }
`

export const RightBox = styled.div`
  min-width: 320px;
  max-width: 320px;
  padding: 32px 40px 0 0;
  display: flex;
  flex-flow: column;
  gap: 24px;

  @media only screen and (max-width: 1130px) {
    min-width: 270px;
    max-width: 270px;
  }

  @media only screen and (max-width: 1080px) {
    min-width: 250px;
    max-width: 250px;
    padding: 32px 20px 0 0;
  }

  ${theme.breakpoints.down('md')} {
    display: none;
  }
`

export const Title = styled.h1`
  font-family:
    Freight Disp Pro,
    sans-serif;
  font-size: 48px;
  margin: 0;
  padding: 0;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${theme.breakpoints.down('sm')} {
    font-size: 32px;
    flex-flow: column-reverse;
    align-items: flex-start;
    gap: 16px;
  }
`

export const SubTitle = styled.h2`
  font-family: Public Sans;
  font-size: 32px;
  margin: 0;
  padding: 0;
  font-weight: 400;
  display: flex;
  gap: 16px;
  align-items: center;

  && img {
    height: 34px;
  }

  && div {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  ${theme.breakpoints.down('sm')} {
    flex-flow: column;
    font-size: 28px;

    align-items: flex-start;
    justify-content: center;

    && img {
      height: 28px;
    }
  }
`

export const SectionTitle = styled.h3`
  font-family: Public Sans;
  font-size: 24px;
  margin: 0;
  padding: 0;
  font-weight: Bold;

  display: flex;
  gap: 16px;
  align-items: center;

  ${theme.breakpoints.down('sm')} {
    font-size: 20px;
  }
`

export const Divider = styled.div`
  background-color: #ebeffc;
  box-sizing: border-box;
  height: 1px;
  margin: 48px 0;

  ${theme.breakpoints.down('md')} {
    margin: 32px 0;
  }

  ${theme.breakpoints.down('sm')} {
    margin: 24px 0;
  }
`

export const DividerNoMargin = styled.div`
  background-color: #ebeffc;
  box-sizing: border-box;
  height: 1px;
`

export const SectionBox = styled.div`
  margin-top: 32px;
`

export const DivisionBox = styled.div`
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #ebeffc;
  border-radius: 2px;
  margin-top: 24px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
  padding: 8px 0;
`

export const NewLabel = styled.div`
  font-size: 10px;
  color: #fff;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 47px;
  height: 19px;
  background-color: #1377d4;
`

export const NextWorkshopBox = styled.div`
  margin-top: 40px;
  background: #e8f3fd;
  display: flex;
  align-items: center;
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 2px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);

  @media only screen and (max-width: 1300px) {
    flex-flow: column;
    align-items: start;
  }

  ${theme.breakpoints.down('md')} {
    flex-flow: row;
    align-items: center;
  }

  ${theme.breakpoints.down('sm')} {
    flex-flow: column;
    align-items: start;
  }
`

export const NextVWStyledIcon = styled.img`
  width: 40px;
  height: 40px;
`

export const NextVWTextBox = styled.div`
  margin-left: 16px;
  display: flex;
  flex-flow: column;
  gap: 4px;
`

export const NextVWText = styled.p<{variant: 'title' | 'body' | 'hint'}>`
  margin: 0;
  padding: 0;

  display: flex;
  align-items: center;
  gap: 8px;

  ${({variant}) =>
    variant === 'title'
      ? `
        color: #000;
        font-size: 16px;
      `
      : variant === 'body'
      ? `
          color: ${colors.bksGray80};
          font-size: 16px;
        `
      : `
        color: ${colors.bksGray70};
          font-size: 14px;
      `}
`

export const NextVWFlexBox = styled.div`
  display: flex;
  align-items: center;
`

export const NextVWButtonBox = styled.div`
  display: flex;
  gap: 40px;
  margin-left: auto;
  padding-left: 16px;

  && a {
    width: 150px;
    height: 40px;
    margin-left: auto;
  }

  @media only screen and (max-width: 1300px) {
    flex-flow: column;
    gap: 16px;
    margin-left: 0;
    padding-left: 0;
    width: 100%;
    padding-top: 16px;

    && a {
      width: 100% !important;
    }
  }

  ${theme.breakpoints.down('md')} {
    flex-flow: row;
    gap: 40px;
    margin-left: auto;
    padding-left: 16px;
    width: auto;

    && button {
      width: 150px !important;
      height: 40px;
      margin-left: auto;
    }
  }

  ${theme.breakpoints.down('sm')} {
    flex-flow: column;
    gap: 16px;
    margin-left: 0;
    padding-left: 0;
    width: 100%;
    padding-top: 16px;

    && button {
      width: 100% !important;
    }
  }
`

export const AddToCalendarBox = styled.div`
  display: flex;
  flex-flow: column;
  font-size: 12px;
  color: ${colors.bksGray70};
  font-style: italic;
  align-items: center;
  cursor: pointer;
  justify-content: center;

  && img {
    width: 20px;
    height: 20px;
  }
`

export const SpacingBox = styled.div`
  margin-top: 40px;
`

export const FAQBox = styled.div`
  background: #fff;
  border: 1px solid #ebeffc;
  border-radius: 2px;
  margin-top: 24px;
  overflow: hidden;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
`

export const FAQItem = styled.div`
  padding: 20px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  color: ${colors.bksGray80};
  align-items: center;
  gap: 8px;
  && img {
    vertical-align: bottom;
    height: 19px;
    margin-left: 8px;
  }
`

export const FAQDescription = styled.div<{
  height?: number
  $isExpanded: boolean
}>`
  color: ${colors.bksGray80};
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 20px;
  ${({$isExpanded, height}) =>
    $isExpanded ? `height: calc(${height}px + 20px);` : `height: 0px;`}
  transition: height 0.3s ease;
`

export const StatusCardBox = styled.div`
  padding-top: 20px;
`
